const formatDistanceLocale = {
  xSeconds: "{{count}}s",
  xMinutes: "{{count}}m",
  xHours: "{{count}}h",
};
export const shortDurationLocale = {
  formatDistance: (token, count) =>
    formatDistanceLocale[token].replace("{{count}}", count),
};
